module.exports = __webpack_public_path__ + "static/media/grzybobranie.b3810469.jpg";